import { render, staticRenderFns } from "./outerSetupSon.vue?vue&type=template&id=4ac562a3&"
import script from "./outerSetupSon.vue?vue&type=script&lang=js&"
export * from "./outerSetupSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports